import { defineComponent as _defineComponent } from 'vue'
import { useLayers } from './composables/useLayers';
import store from '@/store';

import type { LayersSettings, LayersFlags, LayersTemplate } from './types';
import type { CanvasEx } from '@/typings/canvas';

import CCollapse from '@/components/CCollapse.vue';
import LayersTree from './tree/LayersTree.vue';
import LayersHeader from './header/LayersHeader.vue';
import { onUnmounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Layers',
  props: {
    settings: null,
    flags: { default: () => ({
            allowSorting: true,
            allowChangingPrintArea: true,
            allowChangingOverlay: true,
            showGroups: true,
            isAbleToGroupOrUnGroup: true,
            enablePageEps: true,
            isAdminTemplateProduct: false,
            startWithCanva: false
        }) },
    canvas: null,
    auxCanvas: null,
    template: null
  },
  emits: ["import-layers", "tree-item-moved", "user-updated"],
  setup(__props: any, { expose, emit }: { emit: ({
    (event: 'import-layers', value: any): void;
    (event: 'tree-item-moved'): void;
    (event: 'user-updated'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { settings: LayersSettings, flags: LayersFlags, canvas: CanvasEx | null, auxCanvas?: CanvasEx | null, template?: LayersTemplate };





const {
    setActiveElement,
    singleGroupSelection,
    initGroupSelectionFromPageEps,
    importLayers,
    refreshLayerPanel
} = useLayers(props, emit);

expose({
    setActiveElement,
    singleGroupSelection,
    initGroupSelectionFromPageEps,
    refreshLayerPanel
});

onUnmounted(() => {
    store.dispatch('storeLayers/clear');
});

const layerTreeItemMove = () => {
    emit('tree-item-moved');
};

return { __sfc: true,emit, props, setActiveElement, singleGroupSelection, initGroupSelectionFromPageEps, importLayers, refreshLayerPanel, layerTreeItemMove, CCollapse, LayersTree, LayersHeader }
}

})